import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Clock } from "lucide-react";

const BusinessCTASection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-12 md:py-24 lg:py-32 px-4 md:px-6 bg-background">
      <div className="container mx-auto max-w-4xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-[28px] sm:text-3xl md:text-5xl lg:text-6xl text-foreground mb-3 md:mb-4 headline-display px-2"
        >
          Be the business that always <span className="ayra-accent">answers</span>.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-base sm:text-lg md:text-xl lg:text-2xl text-muted-foreground mb-6 md:mb-8 body-text"
        >
          Never miss another customer.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Button
            size="lg"
            className="w-full sm:w-auto bg-foreground text-background px-6 md:px-10 py-4 md:py-7 text-sm sm:text-base md:text-lg font-medium"
          >
            Get Started
            <ArrowRight className="ml-2 h-4 md:h-5 w-4 md:w-5" />
          </Button>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-5 md:mt-8 text-sm md:text-base text-muted-foreground"
        >
          Ayra AI. AI employees for your business.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-3 md:mt-4 flex items-center justify-center gap-2 text-xs md:text-sm text-muted-foreground"
        >
          <Clock className="h-3 md:h-4 w-3 md:w-4" />
          Start today. See results tomorrow.
        </motion.div>
      </div>
    </section>
  );
};

export default BusinessCTASection;
